import React, { useEffect } from "react";
import { Content, Header } from "_c/Modals";
import { tAbstractModalProps } from "@/types";
import HighlightedCities from "@/components/modules/geo/HighlightedCities";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

export type tProps = Pick<tAbstractModalProps<{}>, "onClose">;

const MastersSearchCityPicker = (props: tProps) => {
  const { t, ready } = useTranslation(["common"], { useSuspense: false });
  const history = useHistory();
  useEffect(() => {
    return history.listen(props.onClose);
  }, []);
  if (!ready) return null;
  return (
    <>
      <Header
        css={`
          @media (max-width: ${({ theme }: any) => theme.mobileBp}) {
            display: none;
          }
        `}
        onClick={props.onClose}
      >
        {t("common:close")}
      </Header>
      <Content
        css={`
          @media (max-width: ${({ theme }: any) => theme.mobileBp}) {
            padding: 0;
          }
        `}
      >
        <HighlightedCities
          onGoBackClick={props.onClose}
          showGoBackButton
          enableSearch
        />
      </Content>
    </>
  );
};

export default MastersSearchCityPicker;
